import { Duration } from "date-fns";

export function isDuration (value: unknown): value is Duration {
  if (!value) return false;

  if (typeof value === "object")
    return true;


  return false;
}
